module.exports = __webpack_public_path__ + "img/lang-TH.87c9881d.svg";